import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import SectionSection from "../../../shared/Section";
import { loadModules, setDefaultOptions } from "esri-loader";

setDefaultOptions({ version: "4.14" });

class HwtsFeatureMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      reportName: "HWTS Feature Service Map",
      gridName: "",
      error: "",
      results: [],
      hwtsLayer: [],
      clusterMap: false,
    };
    this.mapRef = React.createRef();
  }

  switchCluster = () => {
    console.log("this.state.clusterMap", this.state.clusterMap);
  };

  createFacilities = () => {
    loadModules([
      "esri/layers/FeatureLayer",
      "esri/layers/support/Field",
      "esri/widgets/Expand",
      "esri/widgets/Search",
      "esri/tasks/Locator",
      "esri/layers/TileLayer",
    ])
      .then(([FeatureLayer, Field, Expand, Search, Locator, TileLayer]) => {
        const facilityRenderer = {
          type: "simple",
          symbol: {
            type: "simple-marker",
            size: 1,
            //color:[0, 255, 255],
            color: [0, 255, 255],
            outline: null,
          },
        };

        const fields = [
          new Field({
            name: "ObjectID",
            alias: "ObjectID",
            type: "oid",
          }),
          new Field({
            name: "FacName",
            alias: "FacName",
            type: "string",
          }),
          new Field({
            name: "EpaId",
            alias: "EpaId",
            type: "string",
          }),
        ];

        var facilitiesPopup = {
          title: "<b>({EpaId}) - {FacName}</b>",
          // "content": "<b>{FacName}</b>"
        };

        const HwtsTileLayer = new TileLayer({
          url:
            "https://dtsc-web05d.dtsc.ca.local/dtsc_dev/rest/services/Hosted/HWTS_Tiles/MapServer",
        });

        // const facilityLayer = new FeatureLayer({
        //     title: 'facility layer',
        //     source: facilities,
        //     fields: fields,
        //     ObjectIDField: 'ObjectID',
        //     renderer: facilityRenderer,
        //     popupTemplate: facilitiesPopup
        // });

        const HwtsLayer = new FeatureLayer({
          url:
            "https://dtsc-web05d.dtsc.ca.local/dtsc_dev/rest/services/HWTS_Facility_Data/FeatureServer/0",
          minScale: 400000,
          renderer: facilityRenderer,
          featureReduction: {
            type: this.state.clusterMap ? "cluster" : false,
            clusterRadius: "100px",
          },
        });

        // var query = HwtsLayer.createQuery();
        // query.where = "Score > 90.0";
        // HwtsLayer.queryFeatures(query).then(function (response) {
        //     console.log("response", response);
        //     this.setState({
        //         hwtsLayer: response,
        //     }, () => {
        //         this.state.map.add(this.state.hwtsLayer);
        //     });
        // });

        this.setState(
          {
            hwtsTileLayer: HwtsTileLayer,
            hwtsLayer: HwtsLayer,
          },
          () => {
            this.state.map.add(this.state.hwtsTileLayer);
            this.state.map.add(this.state.hwtsLayer);
          }
        );
      })
      .catch((err) => console.error(err));
  };

  createMap = () => {
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(
      [
        "esri/WebMap",
        "esri/views/MapView",
        "esri/views/SceneView",
        "esri/Basemap",
        "esri/layers/FeatureLayer",
        "esri/renderers/DotDensityRenderer",
        "esri/widgets/Legend",
        "esri/webmap/Bookmark",
        "esri/widgets/Bookmarks",
        "esri/widgets/Expand",
        "esri/widgets/LayerList",
        "esri/widgets/Slider",
        "esri/widgets/ScaleBar",
        "esri/geometry/Extent",
        "esri/widgets/Locate",
      ],
      { css: true }
    ).then(
      ([
        WebMap,
        MapView,
        SceneView,
        Basemap,
        FeatureLayer,
        DotDensityRenderer,
        Legend,
        Bookmark,
        Bookmarks,
        Expand,
        LayerList,
        Slider,
        ScaleBar,
        Extent,
        Locate,
      ]) => {
        const map = new WebMap({
          portalItem: {
            id: "da83595b291349b79c7e56e5fabc5fde",
          },
          //basemap: Basemap.fromId("streets-night-vector"),
          center: [-122.057281, 38.250313],
          zoom: 10,
        });

        map.center = [-122.057281, 38.250313];

        this.setState(
          {
            map: map,
          },
          () => {
            this.createFacilities();
          }
        );

        //2d View
        this.view = new MapView({
          container: this.mapRef.current,
          map: this.state.map,
          center: [-122.057281, 38.250313],
          zoom: 8,
          highlightOptions: {
            fillOpacity: 0,
            color: [50, 50, 50],
          },
          popup: {
            dockEnabled: true,
            dockOptions: {
              position: "top-right",
              breakpoint: false,
            },
          },
          constraints: {
            maxScale: 35000,
            minScale: 10000000,
          },
        });

        //3d View
        // this.view = new SceneView({
        //     container: this.mapRef.current,
        //     map: this.state.map,
        //     center: [-122.057281, 38.250313],
        //     zoom: 8,
        //     highlightOptions: {
        //         fillOpacity: 0,
        //         color: [50, 50, 50]
        //     },
        //     popup: {
        //         dockEnabled: true,
        //         dockOptions: {
        //             position: "top-right",
        //             breakpoint: false
        //         }
        //     },
        //     constraints: {
        //         maxScale: 35000,
        //         minScale: 10000000
        //     }
        // });

        var legend = new Legend({
          view: this.view,
          container: "legendDiv",
        });
        var legendContainer = document.getElementById("legendDiv");

        // this.view.ui.add([
        //     // new Expand({
        //     //     view: this.view,
        //     //     content: new Legend({ view: this.view }),
        //     //     group: "top-left",
        //     //     expanded: true
        //     // }),
        //     new Expand({
        //         view: this.view,
        //         content: document.getElementById("controlDiv"),
        //         group: "top-left",
        //         expanded: true,
        //         expandIconClass: "esri-icon-layer-list"
        //     }),
        //     new Expand({
        //         view: this.view,
        //         expandIconClass: "esri-icon-filter",
        //         content: document.getElementById("sliderDiv"),
        //         group: "top-left"
        //     }),
        // ], "top-left");

        var scaleBar = new ScaleBar({
          view: this.view,
        });

        var bookmarks = new Bookmarks({
          view: this.view,
          editingEnabled: true,
          bookmarks: [],
        });

        var sacramentoBookmark = new Bookmark({
          name: "Sacramento",
          extent: new Extent({
            xmin: -121.381607,
            xmax: -121.592883,
            ymin: 38.538727,
            ymax: 38.619837,
          }),
        });

        var sanFranciscoBookmark = new Bookmark({
          name: "San Francisco",
          extent: new Extent({
            xmin: -122.038817,
            xmax: -122.752494,
            ymin: 37.615527,
            ymax: 37.880657,
          }),
        });

        var losAngelesBookmark = new Bookmark({
          name: "Los Angeles",
          extent: new Extent({
            xmin: -117.268015,
            xmax: -118.80107,
            ymin: 33.702436,
            ymax: 34.24332,
          }),
        });

        bookmarks.bookmarks.push(sacramentoBookmark);
        bookmarks.bookmarks.push(sanFranciscoBookmark);
        bookmarks.bookmarks.push(losAngelesBookmark);

        this.view.ui.add(
          new Expand({
            view: this.view,
            //content: new Bookmarks({ view: this.view }),
            content: bookmarks,
            group: "bottom-right",
            expanded: false,
          }),
          "bottom-right"
        );

        this.view.ui.add(scaleBar, "bottom-right");

        // var button = new ({
        //     view: this.view,
        // });

        this.view.ui.add("<button>test</button>", "bottom-left");

        var locate = new Locate({
          view: this.view,
        });

        this.view.ui.add(locate, "top-left");
      }
    );
    this.setState({
      view: this.view,
    });
  };
  componentDidMount() {
    document.title = this.state.reportName;
    // this.createFacilities();
    this.createMap();
  }

  componentDidUpdate() {}

  componentWillUnmount() {
    if (this.view) {
      // destroy the map view
      this.view.container = null;
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.callAPI();
  };

  render() {
    return (
      <div>
        <SectionSection
          title={
            <Link to="/reports" style={{ color: "white" }}>
              {this.state.reportName}
            </Link>
          }
          type={"standout"}
        />
        <div className="" style={{ position: "relative" }}>
          <div className="webmap-full" ref={this.mapRef} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(HwtsFeatureMap);
